// @flow
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import type { GatsbyBrowser } from 'gatsby'

import '@toggl/polyfill'
import '@toggl/cookie-warning'
import { callback } from '@toggl/auth'
import { tracer } from '@toggl/bugsnag'
import Bugsnag from '@bugsnag/js'
import intercom from '@toggl/intercom'

import wrapWithProvider from './src/layouts/wrap-with-provider'

declare var process: WebProcess
declare var document: Document
type $GatsbyBrowser<API: string> = $ElementType<GatsbyBrowser, API>

export const wrapRootElement: $GatsbyBrowser<
  'wrapRootElement'
  // $FlowFixMe: Type this some other time.
> = wrapWithProvider

window.__tracer = Bugsnag.getPlugin(tracer.name).tracer

if (!window.intercom) {
  intercom.initialize({
    app_id: process.env.GATSBY_INTERCOM_APP_ID,
    vertical_padding: 20,
    horizontal_padding: 20,
  })

  intercom.load()
  intercom.boot()
  intercom.update({ hide_default_launcher: true })
}

export const onClientEntry: $GatsbyBrowser<'onClientEntry'> = () => {
  callback.redirectLegacyAuthCallbacks()
  require('@toggl/cookie-warning')
}
